import Aboutus from "../components/Aboutus/Aboutus";

const AboutusPage = () => {
    return <Aboutus />;
  };
  
  export default AboutusPage;
  